import { Box, Card, Grid, Typography } from '@mui/material';

import {
  SendRequestForm,
  SupportEmailCard,
  SupportNumberCard,
  useSupportPageStyles
} from '@uplift/pages';
import { useL10n } from '@uplift/hooks';

import { MainLayout } from '../../components';
import { UpliftThemeProvider } from '@uplift/ui-v2';
import { useCurrentuser } from '@uplift/contexts';
import { UserRole } from '@uplift/types';


export const SupportPage = () => {
  const l10n = useL10n();
  const { classes } = useSupportPageStyles();
  const me = useCurrentuser();

  return (
    <MainLayout>
      <UpliftThemeProvider>
        <Box mb={7} color="darkSlate">
          <Typography variant="h3">{l10n.pages.support}</Typography>
        </Box>
        <Box mb={5} color="darkSlate">
          <Typography variant="h1">{l10n.support.pageTitle}</Typography>
        </Box>

        <Box display="flex" flex={1}>
          <Grid container className={classes.grid}>
            <Box className={classes.gridItem}>
              <Card className={classes.cardLeft}>
                <SendRequestForm />
              </Card>
            </Box>
            <Box className={classes.gridItem}>
              <SupportNumberCard />
              <SupportEmailCard />
            </Box>
          </Grid>
        </Box>
        {me.role === UserRole.patient && (
          <Box className={classes.footer}>
            <Typography variant="caption" color="textSecondary">
              <span dangerouslySetInnerHTML={{ __html: l10n.support.footerPatient }} />
            </Typography>
          </Box>
        )}
      </UpliftThemeProvider>
    </MainLayout>
  );
};
